import { Tabs, TabsContent, TabsList, TabsTrigger } from '@design-system';
import {
  EmailTab,
  BulkEmailTab,
  LinkTab,
  useInviteClientTrigger,
  type TabType,
} from '@/features/invite-client';

import { Link2, Mail, Users } from 'lucide-react';

export function InviteClientTabs() {
  const { inviteClientTab, setInviteClientTab } = useInviteClientTrigger();

  const currentTab = inviteClientTab || 'email';

  return (
    <Tabs
      value={currentTab}
      onValueChange={value => setInviteClientTab(value as TabType)}
      className="w-full"
    >
      <TabsList className="w-full">
        <TabsTrigger
          value="email"
          className="flex-1 gap-2"
        >
          <Mail className="hidden size-4 sm:block" />
          Single invite
        </TabsTrigger>
        <TabsTrigger
          value="bulk"
          className="flex-1 gap-2"
        >
          <Users className="hidden size-4 sm:block" />
          Invite multiple
        </TabsTrigger>
        <TabsTrigger
          value="link"
          className="flex-1 gap-2"
        >
          <Link2 className="hidden size-4 sm:block" />
          Share via link
        </TabsTrigger>
      </TabsList>
      <TabsContent
        value="email"
        className="mt-4"
      >
        <EmailTab />
      </TabsContent>
      <TabsContent
        value="bulk"
        className="mt-4"
      >
        <BulkEmailTab />
      </TabsContent>
      <TabsContent
        value="link"
        className="mt-4"
      >
        <LinkTab />
      </TabsContent>
    </Tabs>
  );
}
